<template>
	<div class="landing-healtcare" v-if="pageFirstPartyData.elements">
		<!-- content home -->
		<div class="heroFonts-reduced">
			<hero :props="pageFirstPartyData.elements"  :heroHome="false"></hero>
		</div>		
		
		<section class="content-articles" v-in-viewport="">
			<div class="inside pad-bottom no-title">
				<h2 class="text-center" v-in-viewport="">{{pageFirstPartyData.elements.title_content.value}}</h2>
				<p class="text-center container pad-top">{{pageFirstPartyData.elements.subtitle_content.value}}</p>
				<div class="row">
					<div class="copy col-xs-12 col-md-8" >
						<div class="inner-text left-content mod-steps">
							<!-- Loop -->
							<template v-for="step in pageFirstPartyData.elements.steps.value">
								<div class="step">
									<div class="ribbon">
										<h3>
											<span class="upper">Step</span>
											<span class="number">{{ modularContent[step].elements.step_number.value }}</span>
											<span class="step-title" v-html="modularContent[step].elements.step_headline.value"></span>
										</h3>
									</div>
									<div class="description" v-html="modularContent[step].elements.step_content.value">
									</div>
								</div>
							 </template>
							<!-- End Loop -->
						</div>
					</div>
					<div class="steps-detail col-xs-12 col-md-4">
						<div class="inner-text" v-html="pageFirstPartyData.elements.main_content.value">

						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Contact Form  -->
		<div class="mod-contactCard">
			<contact :contactFormInfo="contactFormInfo"></contact>
		</div>

		<div class="clearfix"></div>

		<section class="contact-section">
			<div class="inside">
				<div class="row">
					<div class="copy col-xs-12 col-md-6 col-lg-8" >
						<h3>About Marcus Thomas LLC</h3>
						<p>Marcus Thomas LLC, with 300 professionals in its offices in Cleveland and Cincinnati, Ohio, Buenos Aires, Argentina and Santiago, Chile, is among America’s leading independent advertising agencies. Marcus Thomas is a recognized leader in digital strategy and technology; is Ohio’s largest media planning and buying agency; has been recognized by the Content Marketing Institute as one of the world’s leading content marketing agencies; and is regularly honored for its award-winning creative and social media campaigns.</p>
						<router-link to="/solutions" tag="button" class="btn_orange">CAPABILITIES</router-link>
					</div>

					<div class="image col-xs-12 col-md-6 col-lg-4">
						<img src="/dist/about.png" alt="" class="o-fit">
					</div>

				</div>
			</div>
		</section>
		
		<!-- Footer -->
		<Footer></Footer>

	</div>
</template>


<script>
	import seoModule from '../mixins/seoModule.js';
	import contactForm from '../components/contact-form-salesforce.vue';
	import hero from '../components/hero-healthcare.vue';
	import Footer from '../layout/footer-component.vue';

		require('../assets/img/about.png');

	export default{
		name:'Home',
		data () {
			return {
				pageFirstPartyData: [],
				modularContent:[],
				contactFormInfo: [],
			}
		},
		created:function(){
			document.body.classList.add("healtcare");
			this.loadFirstPartyData();
		},
		mounted: function() {
			let _this = this;
			setTimeout(function(){
				$('.st-sticky-share-buttons').removeClass('st-sticky-share-buttons-show');
			},500);
		},
		methods: {
			loadFirstPartyData() {
				this.$http.get("/src/data_jsons/firstpartydata_data.json").then((response) => {
					let formInfo = response.body.items[0].elements.contact_form.value[0];
					this.pageFirstPartyData = response.body.items[0];
					this.modularContent = response.body.modular_content;
					this.contactFormInfo = response.body.modular_content[formInfo].elements;
					
					// Show footer after loading data
					setTimeout(function () {
						$("#footer").show();
					}, 500);
				});
			}
		},
		computed: {
			version: function(){
				return 'v2';
			}
		},
		components:{
			'hero':hero,
			'Footer':Footer,
			'contact': contactForm
		},
		mixins:[seoModule]
	}
</script>



// WEBPACK FOOTER //
// FirstPartyData.vue?391b76c0